import { useEffect } from 'react'
import PageHeader from 'components/PageHeader'
import Button from 'components/form/Button'
import Icon from 'components/Icon'
import { useDispatch, useSelector } from 'react-redux'
import ProposalKeyword from './ProposalKeyword'
import PredictKeyword from 'features/keywordPlanner/PredictKeyword'
import { reset } from 'features/keywordPlanner/proposalKeywordSlice'
import { useParams } from 'react-router-dom'

const KeywordPlanner = () => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const { visible } = useSelector(state => state.keywordPlanner.predictKeyword)

  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )

  return (
    <div className="keywordplanner_wrap">
      <div className="dsp_tit">
        <PageHeader pageTitle="키워드 플래너">
          <div className="f_right">
            <Button line linkTo={`/${adAccountId}/bulks/keyword-planner`}>
              대량조회로 이동
              <Icon name="outlink" className="img_comm" />
            </Button>
          </div>
        </PageHeader>
      </div>
      {visible ? <PredictKeyword /> : <ProposalKeyword />}
    </div>
  )
}
export default KeywordPlanner
